
import Glide from '@glidejs/glide';
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import Typed from 'typed.js';
import gsap from 'gsap';
import _ from 'lodash';

export default {
  init() {
    // JavaScript to be fired on the home page

    // Default

    $(function () {

      // Typewriter

      let options = {
        stringsElement: '#type-array',
        typeSpeed: 50,
        backSpeed: 50,
        backDelay: 1500,
        loop: true,
      };

      new Typed('#hero-typewriter', options);

      let syncGlide = (master, slave) => {
        master.on('run', (e) => {
          if (e.direction === '=') {
            slave.go('=' + e.steps);
          } else {
            slave.go(e.direction);
          }
        });
      };

      const gliders = document.querySelectorAll('.basic-glide');
      gliders.forEach(glide => {
        new Glide(glide, {
          type: 'carousel',
          autoplay: 6000,
        }).mount();
      });

      let testimonialGliderHTML = document.querySelector('.testimonial-glide');
      let testimonialGliderSlides = testimonialGliderHTML.querySelectorAll('.glide__slide');
      const testimonialGliders = new Glide(testimonialGliderHTML, {
        type: 'carousel',
        autoplay: 6000,
      });

      testimonialGliders.on('run', () => {
        let current = testimonialGliderHTML.querySelector('.glide__transitioning');
        if (current) {
          current.classList.remove('glide__transitioning');
        }

        testimonialGliderSlides[testimonialGliders.index].classList.add('glide__transitioning');
      });

      testimonialGliders.mount();

      const testimonialLogoGliders = new Glide(document.querySelector('.testimonial-logo-glide'), {
        type: 'carousel',
        gap: 0,
      }).mount();

      syncGlide(testimonialGliders, testimonialLogoGliders);
      syncGlide(testimonialLogoGliders, testimonialGliders);

      const expertise = document.querySelectorAll('.expertise--glide');
      if (expertise) {

        expertise.forEach(type => {

          let expertiseGlider = new Glide(type, {
            type: 'slider',
            rewind: false,
            // autoplay: 6000,
          });

          let start = true;

          expertiseGlider.on('run', () => {
            if (start) {
              start = false;
              let track = type.querySelector('.expertise--slide');
              track.classList.add('glide__start');
            }
          });

          expertiseGlider.mount();
        });
      }

      const articles = document.querySelector('.article--glide');
      if (articles) {

        let articleGlider = new Glide(articles, {
          type: 'carousel',
          gap: 0,
          autoplay: 6000,
          dragThreshold: 120,
          swipeThreshold: 120,
        });

        // let start = false;
        // let moving = false;
        let index = articleGlider.index;
        let contentGroup = document.querySelector('.article--contents');
        let contents = contentGroup.querySelectorAll('.article--content');

        $(document).on('click', '.glide__slide--active[data-article-slider]', function () {
          let postId = $(this).data('article-slider');
          loadArticle(postId);
        });

        $(document).on('click', '.glide__slide.previous--slider', function () {
          // console.log('prev');
          articleGlider.go('<');
        });

        $(document).on('click', '.glide__slide.next--slider', function () {
          // console.log('next');
          articleGlider.go('>');
        });

        articleGlider.on('build.before', () => {
          let track = articles.querySelector('.article--slide');
          track.classList.add('glide__start');

          let activeContent = contents[articleGlider.index];
          let activeTitle = activeContent.querySelector('.article--card');

          gsap.fromTo(activeContent,
            {
              autoAlpha: 0,
              zIndex: 2,
              display: 'flex',
            },
            {
              autoAlpha: 1,
            });
          gsap.fromTo(activeTitle,
            {
              x: '100',
            },
            {
              x: '0',
            });

          activeContent.classList.add('active__content');
        });

        articleGlider.on('mount.after', () => {
          $('.glide__slide--active[data-article-slider]').prev().addClass('previous--slider');
          $('.glide__slide--active[data-article-slider]').next().addClass('next--slider');
        });

        articleGlider.on('move', () => {

          let active = articles.querySelectorAll('.glide__slide:not(.glide__slide--clone)')[articleGlider.index];
          let previous = articles.querySelector('.glide__slide--active');

          let activeContent = contents[articleGlider.index];
          let activeTitle = activeContent.querySelector('.article--card');

          let prevContent = contentGroup.querySelector('.active__content');

          // moving = true;

          if (index != articleGlider.index) {

            if (prevContent) {

              if (prevContent !== activeContent) {
                prevContent.classList.remove('active__content');
                let prevTitle = prevContent.querySelector('.article--card');

                gsap.to(prevContent,
                  {
                    autoAlpha: 0,
                    zIndex: 1,
                    display: 'none',
                  });
                gsap.to(prevTitle,
                  {
                    x: '-50',
                  });
              }
            }

            gsap.fromTo(activeContent,
              {
                autoAlpha: 0,
                zIndex: 2,
                display: 'flex',
              },
              {
                autoAlpha: 1,
              });
            gsap.fromTo(activeTitle,
              {
                x: '100',
              },
              {
                x: '0',
              });

            activeContent.classList.add('active__content');

            active.classList.add('glide__transitioning');
            if (previous) {
              previous.classList.add('glide__previous');
            }
          }

        });

        articleGlider.on('move.after', () => {
          if (index != articleGlider.index) {
            let transitioning = articles.querySelector('.glide__transitioning');
            let transitioned = articles.querySelector('.glide__previous');

            if (transitioning) {
              transitioning.classList.remove('glide__transitioning');
            }

            if (transitioned) {
              transitioned.classList.remove('glide__previous');
            }

            index = articleGlider.index;
          }

        });

        articleGlider.mount();
      }

    });

    // Post links 
    $(document).on('click', '.post-content a.link', (e) => {
      if (window.location.hostname == e.target.hostname) { // make use of window.location.hostname here to get hostname of current webpage
        if (e.target.href.indexOf(window.location.href) > -1) {
          e.preventDefault();
          let href = e.target.hash;
          slideOut();
          gsap.to(window, {
            duration: 1,
            scrollTo: href,
          });
        }
      }
    });

    // Sidebar
    let sideContainer = document.querySelector('.float--container');
    let sidebar = document.querySelector('.float--side');
    let articles = document.querySelectorAll('[data-article]');
    let caseStudies = document.querySelectorAll('[data-case-study]');
    let articlePosts = document.querySelectorAll('[data-article-post]');
    let casePosts = document.querySelectorAll('[data-case-study-post]');
    let privacyPost = document.querySelector('[data-privacy]');
    let privacyBtn = document.querySelectorAll('[data-privacy-btn]');

    let currentGlide;

    let goSlide;
    let arrows;

    let initSlider = (post) => {
      let glide = post.querySelector('.glide');
      if (glide) {
        let pg = new Glide(glide, {
          type: 'carousel',
          swipeThreshold: 20,
          dragThreshold: 60,
        });

        currentGlide = pg;

        let index = pg.index;

        goSlide = (e) => {
          let go = e.target.dataset.glideDir;
          pg.go(go);
        };

        arrows = glide.querySelectorAll('[data-arrow-dir]');
        if (arrows) {
          arrows.forEach(a => {
            a.addEventListener('click', goSlide);
          });
        }

        pg.on('move.after', () => {
          if (index != pg.index) {
            document.querySelectorAll('.glide__slide video').forEach(v => {
              v.pause();
            });
          }
          index = pg.index;
        });

        pg.on('run.after', () => {

          console.log('glide move');
          const activeSlide = glide.querySelector('.glide__slide--active');
          console.log(activeSlide);
          const slideVideo = activeSlide.querySelector('video');
          if (slideVideo) {
            slideVideo.play();
          }
          console.log(slideVideo);
        });

        pg.mount();
      }
    }

    caseStudies.forEach(c => {
      c.addEventListener('click', () => {
        let cs = c.dataset.caseStudy;
        let i = c.dataset.slide;
        loadCaseStudy(cs, i);
        // startSlider(i);
      });
    });

    articles.forEach(article => {
      article.addEventListener('click', () => {
        let i = article.dataset.article;
        loadArticle(i);
      });
    });

    privacyBtn.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        loadPrivacy();
      });
    });

    let setArticlePosts = () => {
      articlePosts.forEach(a => {
        gsap.set(a, {
          autoAlpha: 0,
          zIndex: -1,
        });
      });
    }

    let setCasePosts = () => {
      casePosts.forEach(c => {
        gsap.set(c, {
          autoAlpha: 0,
          zIndex: -1,
        });
      });
    }

    let setPrivacyPost = () => {
      gsap.set(privacyPost, {
        autoAlpha: 0,
        zIndex: -1,
      });
    }

    let loadPrivacy = () => {
      privacyPost.scrollTop = 0;
      slideIn(privacyPost);
      gsap.to(privacyPost, {
        autoAlpha: 1,
      });
      let close = privacyPost.querySelector('[data-close-post]');
      close.addEventListener('click', closePost);
    }

    let loadCaseStudy = (id) => {
      let casestudy = document.querySelector('[data-case-study-post="' + id + '"]');
      let firstSlide = casestudy.querySelector('.glide__slide');
      let firstSlideVideo = firstSlide.querySelector('video');

      slideIn(casestudy);
      casestudy.scrollTop = 0;
      // casestudy.scrollTo(0, 0);
      gsap.to(casestudy, {
        autoAlpha: 1,
      });

      if (firstSlideVideo) {
        firstSlideVideo.play();
      }

      let close = casestudy.querySelector('[data-close-post]');
      close.addEventListener('click', closePost);

      let postNav = document.querySelectorAll('[data-go-post]');
      postNav.forEach(pn => {
        pn.addEventListener('click', goPost);
      });
    }

    let loadArticle = (id) => {
      let article = document.querySelector('[data-article-post="' + id + '"]');
      slideIn(article);
      article.scrollTop = 0;
      gsap.to(article, {
        autoAlpha: 1,
      });

      let postNav = document.querySelectorAll('[data-go-post]');
      postNav.forEach(pn => {
        pn.addEventListener('click', goPost);
      });

      let close = article.querySelector('[data-close-post]');
      close.addEventListener('click', closePost);
    }

    let closePost = (e) => {
      e.target.removeEventListener('click', closePost);
      slideOut();
    }

    let s = () => {
      gsap.set(sidebar, {
        x: '+=' + sidebar.getBoundingClientRect().width,
        autoAlpha: 0,
      });
      setArticlePosts();
      setCasePosts();
      setPrivacyPost();
    }

    let slideIn = (post) => {
      gsap.fromTo(sideContainer,
        {
          autoAlpha: 1,
          display: 'block',
          zIndex: 10001,
          backgroundColor: 'rgba(0,0,0,0)',
        },
        {
          backgroundColor: 'rgba(0,0,0,0.85)',
        });
      gsap.fromTo(sidebar,
        {
          display: 'block',
        }, {
        x: 0,
        autoAlpha: 1,
      });

      initSlider(post);

      disableBodyScroll(post, {
        'reserveScrollBarGap': true,
      });

      sideContainer.addEventListener('click', function (e) {
        if (e.target !== this) {
          return;
        }
        slideOut(post);
      });
    };

    let slideOut = () => {
      clearAllBodyScrollLocks();
      setArticlePosts();
      setCasePosts();
      setPrivacyPost();
      if (arrows) {
        arrows.forEach(a => {
          a.removeEventListener('click', goSlide);
        });
      }
      document.querySelectorAll('.glide__slide video').forEach(v => {
        v.pause();
      });

      gsap.to(sidebar,
        {
          display: 'none',
          x: sidebar.getBoundingClientRect().width,
          autoAlpha: 0,
        });
      gsap.to(sideContainer,
        {
          display: 'none',
          zIndex: -1,
          backgroundColor: 'rgba(0,0,0,0)',
        });

      if (currentGlide) {
        currentGlide.destroy();
        currentGlide = null;
      }
    };

    let goPost = (e) => {
      let id = e.target.dataset.goPost;
      casePosts.forEach(c => {
        gsap.to(c, {
          autoAlpha: 0,
        });
      });
      document.querySelectorAll('.glide__slide video').forEach(v => {
        v.pause();
      });

      if (arrows) {
        arrows.forEach(a => {
          a.removeEventListener('click', goSlide);
        });
      }

      if (currentGlide) {
        currentGlide.destroy();
        currentGlide = null;
      }

      let casestudy = document.querySelector('[data-case-study-post="' + id + '"]');
      gsap.to(casestudy, {
        autoAlpha: 1,
      });
      casestudy.scrollTop = 0;

      let firstSlide = casestudy.querySelector('.glide__slide');
      let firstSlideVideo = firstSlide.querySelector('video');
      if (firstSlideVideo) {
        firstSlideVideo.play();

      }

      initSlider(casestudy);

      let close = casestudy.querySelector('[data-close-post]');
      close.addEventListener('click', closePost);

      let postNav = document.querySelectorAll('[data-go-post]');
      postNav.forEach(pn => {
        pn.addEventListener('click', goPost);
      });

      clearAllBodyScrollLocks();
      disableBodyScroll(casestudy, {
        'reserveScrollBarGap': true,
      });
    }

    s();

    // Animation

    let insideout = document.querySelector('#inside-out');

    let inside = insideout.querySelector('.inside');
    let out = insideout.querySelector('.out');
    let business = insideout.querySelector('.business');
    let messy = insideout.querySelector('.messy');

    let insideText = insideout.querySelector('.inside-text');
    let outText = insideout.querySelector('.out-text');
    let messyText = insideout.querySelector('.messy-text');

    let leftCross = insideout.querySelector('.cross-main-left');
    let rightCross = insideout.querySelector('.cross-main-right');
    let leftBackCross = insideout.querySelector('.cross-back-left');
    let rightBackCross = insideout.querySelector('.cross-back-right');

    gsap.set(inside, {
      fontSize: 46,
      autoAlpha: 0,
      x: 180,
      y: 220,
    });
    gsap.set(out, {
      fontSize: 46,
      autoAlpha: 0,
      x: 435,
      y: 220,
    });
    gsap.set(business, {
      fontSize: 46,
      scale: 0.35,
      x: 200,
      y: 35,
      autoAlpha: 0,
    });
    gsap.set(messy, {
      fontSize: 46,
      scale: 0.35,
      x: 155,
      y: 440,
      autoAlpha: 0,
    });
    gsap.set(insideText, {
      autoAlpha: 0,
      x: 0,
      y: 225,
    });
    gsap.set(outText, {
      autoAlpha: 0,
      x: 480,
      y: 225,
    });
    gsap.set(messyText, {
      autoAlpha: 0,
      x: 230,
      y: 450,
    });
    gsap.set(leftCross, {
      autoAlpha: 0,
      backgroundColor: '#FFF',
      width: 64,
      height: 4,
      y: 250,
      x: 350,
    });
    gsap.set(rightCross, {
      autoAlpha: 0,
      backgroundColor: '#FFF',
      width: 64,
      height: 4,
      rotate: 90,
      y: 250,
      x: 350,
    });
    gsap.set(leftBackCross, {
      autoAlpha: 0,
      x: 272,
      y: 250,
      width: 220,
      rotate: 135,
      borderTop: '1px solid #d8ff00',
    });
    gsap.set(rightBackCross, {
      autoAlpha: 0,
      x: 272,
      y: 250,
      width: 220,
      rotate: 45,
      borderTop: '1px solid #d8ff00',
    });

    let tl = gsap.timeline({
      repeat: 0,
      paused: true,
    });

    tl.to(inside, {
      duration: 2,
      autoAlpha: 1,
    }).to(out, {
      duration: 2,
      autoAlpha: 1,
    }, '<').to(leftCross, {
      duration: 2,
      autoAlpha: 1,
    }, '<').to(rightCross, {
      duration: 2,
      autoAlpha: 1,
    }, '<').to(inside, {
      x: '-=' + 50,
      // fontSize: 26,
      scale: 0.6,
    }).to(out, {
      x: '+=' + 50,
      // fontSize: 26,
      scale: 0.6,
    }, '<').to(leftCross, {
      rotate: '+=' + 45,
    }).to(rightCross, {
      rotate: '+=' + 45,
    }, '<').to(leftCross, {
      width: 220,
      x: '-=' + 78,
    }).to(rightCross, {
      width: 220,
      x: '-=' + 78,
    }, '<').to(leftBackCross, {
      autoAlpha: 1,
      width: 690,
      x: '-=' + 235,
    }).to(rightBackCross, {
      autoAlpha: 1,
      width: 690,
      x: '-=' + 235,
    }, '<').to(messy, {
      autoAlpha: 1,
    }).to(business, {
      autoAlpha: 1,
    }, '<').to(inside, {
      x: '-=' + 75,
      scale: 0.35,
    }, '<').to(out, {
      x: '+=' + 85,
      scale: 0.35,
    }, '<').to(messyText, {
      autoAlpha: 1,
    }).to(insideText, {
      autoAlpha: 1,
    }, '<').to(outText, {
      autoAlpha: 1,
    }, '<').to(inside, {
      y: 175,
    }, '<').to(out, {
      y: 175,
    }, '<').to(messy, {
      y: 400,
    }, '<');

    function inViewport(el) {
      var r;
      r = el.getBoundingClientRect();
      return (!!r &&
        r.top <= (window.innerHeight || document.documentElement.clientHeight) / 2
        // r.left >= 0 &&
        // r.right <= (window.innerWidth || document.documentElement.clientWidth) &&
        // r.bottom <= (window.innerHeight || document.documentElement.clientHeight)/2 
      );
    }

    function startAnimation() {
      if (inViewport(insideout)) {
        window.removeEventListener('scroll', throttleStart);
        window.removeEventListener('load', throttleStart);
        tl.resume();
      }
    }

    const throttleStart = _.throttle(startAnimation, 300);

    window.addEventListener('scroll', throttleStart);
    window.addEventListener('load', throttleStart);


    /**
     * Mobile animation
     */

    let insideoutmob = document.querySelector('#inside-out-mob');

    let insidemob = insideoutmob.querySelector('.inside');
    let outmob = insideoutmob.querySelector('.out');
    let businessmob = insideoutmob.querySelector('.business');
    let messymob = insideoutmob.querySelector('.messy');

    let insideTextmob = insideoutmob.querySelector('.inside-text');
    let outTextmob = insideoutmob.querySelector('.out-text');
    let messyTextmob = insideoutmob.querySelector('.messy-text');

    let leftCrossmob = insideoutmob.querySelector('.cross-main-left');
    let rightCrossmob = insideoutmob.querySelector('.cross-main-right');
    let leftBackCrossmob = insideoutmob.querySelector('.cross-back-left');
    let rightBackCrossmob = insideoutmob.querySelector('.cross-back-right');

    gsap.set(insidemob, {
      x: 6,
      y: 160,
    });
    gsap.set(outmob, {
      x: 190,
      y: 160,
    });
    gsap.set(businessmob, {
      x: 80,
      y: 61,
    });
    gsap.set(messymob, {
      x: 70,
      y: 258,
    });
    gsap.set(leftCrossmob, {
      backgroundColor: '#fff',
      width: 108,
      height: 4,
      x: 63,
      y: 177,
      rotate: '-=' + 45,
    });
    gsap.set(rightCrossmob, {
      backgroundColor: '#ffff',
      width: 108,
      height: 4,
      rotate: '+=' + 45,
      x: 64,
      y: 177,
    });
    gsap.set(leftBackCrossmob, {
      x: -127,
      y: 177,
      width: 490,
      rotate: -45,
      borderTop: '1px solid #d8ff00',
    });
    gsap.set(rightBackCrossmob, {
      x: -127,
      y: 177,
      width: 490,
      rotate: 45,
      borderTop: '1px solid #d8ff00',
    });
    gsap.set(insideTextmob, {
      autoAlpha: 0,
      x: 0,
      y: 155,
    });
    gsap.set(outTextmob, {
      autoAlpha: 0,
      x: 100,
      y: 155,
    });
    gsap.set(messyTextmob, {
      autoAlpha: 1,
      x: 19,
      y: 310,
    });

    insidemob.addEventListener('click', () => {
      if (insidemob.classList.contains('opened')) {
        insidemob.classList.remove('opened');

        let insideClose = gsap.timeline({
          repeat: 0,
          // paused: true,
        });

        insideClose.to(leftBackCrossmob, {
          x: '-=140',
        }, '<').to(leftCrossmob, {
          x: '-=140',
        }, '<').to(rightBackCrossmob, {
          x: '-=140',
        }, '<').to(rightCrossmob, {
          x: '-=140',
        }, '<').to(messymob, {
          x: '-=140',
          autoAlpha: 1,
        }, '<').to(messyTextmob, {
          x: '-=140',
          autoAlpha: 1,
        }, '<').to(businessmob, {
          x: '-=140',
          autoAlpha: 1,
        }, '<').to(outmob, {
          x: '-=140',
          autoAlpha: 1,
        }, '<').to(insidemob, {
          x: '-=140',
        }, '<').to(insideTextmob, {
          autoAlpha: 0,
        }, '<');

      } else {
        insidemob.classList.add('opened');

        let insideOpen = gsap.timeline({
          repeat: 0,
          // paused: true,
        });

        insideOpen.to(leftBackCrossmob, {
          x: '+=140',
        }, '<').to(leftCrossmob, {
          x: '+=140',
        }, '<').to(rightBackCrossmob, {
          x: '+=140',
        }, '<').to(rightCrossmob, {
          x: '+=140',
        }, '<').to(messymob, {
          x: '+=140',
          autoAlpha: 0,
        }, '<').to(messyTextmob, {
          x: '+=140',
          autoAlpha: 0,
        }, '<').to(businessmob, {
          x: '+=140',
          autoAlpha: 0,
        }, '<').to(outmob, {
          x: '+=140',
          autoAlpha: 0,
        }, '<').to(insidemob, {
          x: '+=140',
        }, '<').to(insideTextmob, {
          autoAlpha: 1,
        }, '<');
      }
    });

    outmob.addEventListener('click', () => {
      if (outmob.classList.contains('opened')) {
        outmob.classList.remove('opened');

        let outClose = gsap.timeline({
          repeat: 0,
          // paused: true,
        });

        outClose.to(leftBackCrossmob, {
          x: '+=140',
        }, '<').to(leftCrossmob, {
          x: '+=140',
        }, '<').to(rightBackCrossmob, {
          x: '+=140',
        }, '<').to(rightCrossmob, {
          x: '+=140',
        }, '<').to(messymob, {
          x: '+=140',
          autoAlpha: 1,
        }, '<').to(messyTextmob, {
          x: '+=140',
          autoAlpha: 1,
        }, '<').to(businessmob, {
          x: '+=140',
          autoAlpha: 1,
        }, '<').to(insidemob, {
          x: '+=140',
          autoAlpha: 1,
        }, '<').to(outmob, {
          x: '+=140',
        }, '<').to(outTextmob, {
          autoAlpha: 0,
        }, '<');

      } else {
        outmob.classList.add('opened');

        let outOpen = gsap.timeline({
          repeat: 0,
          // paused: true,
        });

        outOpen.to(leftBackCrossmob, {
          x: '-=140',
        }, '<').to(leftCrossmob, {
          x: '-=140',
        }, '<').to(rightBackCrossmob, {
          x: '-=140',
        }, '<').to(rightCrossmob, {
          x: '-=140',
        }, '<').to(messymob, {
          x: '-=140',
          autoAlpha: 0,
        }, '<').to(messyTextmob, {
          x: '-=140',
          autoAlpha: 0,
        }, '<').to(businessmob, {
          x: '-=140',
          autoAlpha: 0,
        }, '<').to(insidemob, {
          x: '-=140',
          autoAlpha: 0,
        }, '<').to(outmob, {
          x: '-=140',
        }, '<').to(outTextmob, {
          autoAlpha: 1,
        }, '<');
      }
    });



    document.querySelectorAll('.glide__slide video').forEach(v => {
      v.addEventListener('mouseover', () => {
        if (!v.hasAttribute('controls')) {
          v.setAttribute('controls', true);
        }
      });

      v.addEventListener('mouseout', () => {
        if (v.hasAttribute('controls')) {
          v.removeAttribute('controls');
        }
      });
    });


    const heroArrow = document.querySelector('.hero-section .fold-arrow');
    const collaboratingSection = document.querySelector('#approach');

    heroArrow.addEventListener('click', () => {
      window.scrollTo({
        top: collaboratingSection.offsetTop,
        behavior: 'smooth',
      });
    });


    const expertiseArrow = document.querySelector('#expertise .fold-arrow');
    const expertiseSection = document.querySelector('.section.expertise');

    expertiseArrow.addEventListener('click', () => {
        window.scrollTo({
          top: expertiseSection.offsetTop,
          behavior: 'smooth',
        });
    });
    /* Expertise icons */

    // let icons = document.querySelectorAll('[data-icon]');

    // let tlIcon = gsap.timeline({
    //   repeat: 0,
    //   paused: true,
    // });

    // tlIcon.to(icons[0], {
    //   x: '+=' + 30,
    //   y: '-=' + 15,
    // }, '<').to(icons[1], {
    //   x: '+=' + 30,
    // }, '<').to(icons[2], {
    //   x: '+=' + 20,
    //   y: '-=' + 20,
    // }, '<');

    // let mobileIcons = () => {
    //   gsap.set(icons[0], {
    //     x: '+=' + 10,
    //     y: '-=' + 3,
    //   });
    //   gsap.set(icons[1], {
    //     x: '+=' + 10,
    //   });
    //   gsap.set(icons[2], {
    //     x: '+=' + 5,
    //     y: '-=' + 5,
    //   });
    // }

    // function startIconAnimation() {
    //   if (icons.length > 0) {
    //     if (inViewport(icons[0])) {
    //       if (window.innerWidth >= 768) {
    //           window.removeEventListener('scroll', throttleIconStart);
    //           window.removeEventListener('load', throttleIconStart);
    //           tlIcon.resume();
    //       } else {
    //         // window.removeEventListener('scroll', throttleIconStart);
    //         // window.removeEventListener('load', throttleIconStart);
    //         // mobileIcons();
    //       }
    //     }
    //   }
    // }

    // const throttleIconStart = _.throttle(startIconAnimation, 300);

    // window.addEventListener('scroll', throttleIconStart);
    // window.addEventListener('load', throttleIconStart);


  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js